import { Component } from '@angular/core';
import { DOCS_ENDPOINTS } from '../data/docs-api-data';

/**
 * Docs landing page (/docs) the "Introduction": hero (title, value
 * props), an "Our endpoints" table, a "How it works" flow, a Playground
 * callout, and "Where to next" cards. Every guide that used to
 * live here as an anchored section within this one page now has its own
 * route and component: see docs-quickstart, docs-authentication,
 * docs-making-a-call, docs-pricing-limits, docs-errors,
 * docs-account-filters (all siblings of this folder under pages/docs/).
 * Content is transcribed from the Mila Developer Portal artifact the
 * backend team provided (2026-08-28).
 *
 * Rendered inside DocsLayout's <router-outlet> (see shared/docs-layout)
 * that's what owns the page shell (top bar, sidebar) and the
 * scroll-container registration for anchor scrolling now; this component
 * contributes only its own content section.
 */
@Component({
  selector: 'app-docs',
  standalone: false,
  templateUrl: './docs.html',
  styleUrl: './docs.scss',
})
export class Docs {
  // DOCS_ENDPOINTS is a static, module-level constant (not app state), so
  // this is computed once as a plain field rather than a template getter
  // re-filtering on every check, or a signal with nothing reactive to
  // depend on. Only 'find' entries exist today (rag/answer/search/image/similar) see
  // docs-api-data.ts's DocsEndpoint.category doc comment.
  readonly findEndpoints = DOCS_ENDPOINTS.filter(ep => ep.category === 'find');
}
